import type { ProductCardProps } from '@skin-seoul/shared-components';
import { VerticalProductCard } from '@skin-seoul/shared-components';
import React from 'react';
import { Flex, HStack, Icon, LucideIcon, Text, VStack } from '@skin-seoul/design-system';
import DirectAddToCart from './DirectAddToCart';
import DesktopProductCardSkeleton from './DesktopProductCard.skeleton';
import { CurrentProductBadge } from './CurrentProductBadge';
import { SafeLink } from '@/components/ui/SafeLink';
type DesktopProductCardProps = ProductCardProps & {
  isSelected?: boolean;
  efficacy?: string[];
  isDisabled?: boolean;
  isCurrent?: boolean;
  onTrackAddToCart?: () => void;
};
const DesktopProductCard = ({
  isSelected = false,
  efficacy = [],
  isDisabled = false,
  isCurrent = false,
  onTrackAddToCart,
  onClick,
  ...cardProps
}: DesktopProductCardProps) => {
  return <VerticalProductCard onClick={onClick} {...cardProps} linkComponent={SafeLink} backgroundColor="white" border="1px solid" borderColor={isSelected ? 'neutral.300' : 'transparent'} p={4} cursor={isDisabled ? 'not-allowed' : 'pointer'} data-sentry-element="VerticalProductCard" data-sentry-component="DesktopProductCard" data-sentry-source-file="DesktopProductCard.tsx">
      {isCurrent && <Flex position="absolute" top={4} left={4} zIndex={2}>
          <CurrentProductBadge />
        </Flex>}
      <VerticalProductCard.Image height="300px" backgroundColor="generic.0" borderRadius="8px" bottomSlot={<DirectAddToCart sku={cardProps.sku} onTrackAddToCart={onTrackAddToCart} mx={{
      base: 1,
      tablet: 2
    }} marginBottom={{
      base: 1,
      tablet: 2
    }} />} data-sentry-element="VerticalProductCard.Image" data-sentry-source-file="DesktopProductCard.tsx" />
      <VerticalProductCard.Content data-sentry-element="VerticalProductCard.Content" data-sentry-source-file="DesktopProductCard.tsx">
        <VStack gap={2} alignItems="start" width="full" data-sentry-element="VStack" data-sentry-source-file="DesktopProductCard.tsx">
          <VerticalProductCard.InfoName data-sentry-element="VerticalProductCard.InfoName" data-sentry-source-file="DesktopProductCard.tsx" />
          <VerticalProductCard.InfoPrice data-sentry-element="VerticalProductCard.InfoPrice" data-sentry-source-file="DesktopProductCard.tsx" />
          <VerticalProductCard.InfoRating data-sentry-element="VerticalProductCard.InfoRating" data-sentry-source-file="DesktopProductCard.tsx" />
          {efficacy.length > 0 && <VStack gap={1} alignItems="start" width="full">
              {efficacy.slice(0, 3).map((efficacyItem, idx) => <HStack key={idx} gap={1}>
                  <Icon color="neutral.400" boxSize={3}>
                    <LucideIcon name="Check" />
                  </Icon>
                  <Text textStyle="label.small" fontWeight="regular" color="neutral.600" as="label" textTransform="capitalize">
                    {efficacyItem}
                  </Text>
                </HStack>)}
            </VStack>}
        </VStack>
      </VerticalProductCard.Content>
    </VerticalProductCard>;
};
DesktopProductCard.Skeleton = DesktopProductCardSkeleton;
export default DesktopProductCard;